import * as React from "react";

import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import Tooltip from "../../components/Tooltip";
import { isEmpty, toFixed } from "../../utils/helpers";
import { format } from "../../utils/dateUtils";

import LinearProgress from "./LinearProgress";

const colorMap = {
  1: {
    cardBackgroundColor: "#FEE1C9",
    barBackgroundColor: "#FDB77E",
    barColor: "#FC8D33"
  },
  2: {
    cardBackgroundColor: "#D6E9FA",
    barBackgroundColor: "#A8D0F5",
    barColor: "#1e88e5"
  },
  3: {
    cardBackgroundColor: "#D1EBD2",
    barBackgroundColor: "#9CD39E",
    barColor: "#429346"
  }
};

const useStyles = makeStyles({
  root: props => ({
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: 200,
    backgroundColor: props.cardBackgroundColor
  }),
  row1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  row1Right: {
    display: "flex",
    alignItems: "center"
  },
  viewIcon: props => ({
    color: props.barColor,
    marginLeft: 12
  }),
  row2: {
    marginBottom: "12px",
    width: "100%"
  },
  row3: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }
});

const KanbanCard = props => {
  const { record, utc_offset, qtyKey, startTimeKey, endTimeKey } = props;

  const { fpoQty } = record || {};
  const qty = record[qtyKey] || 0;
  const startTime = record[startTimeKey];
  const endTime = record[endTimeKey];

  const progress = fpoQty > 0 ? (qty * 100) / fpoQty : 0;
  const colorKeyValue = toFixed(progress, 0) >= 100 ? 3 : progress === 0 ? 1 : 2;
  const colors = colorMap[colorKeyValue];

  const classes = useStyles(colors);

  const metaList = !isEmpty(record?.meta) ? JSON.parse(record.meta) : [];
  const finalQty = metaList.some(meta => !isEmpty(meta.conversionError)) && ["grnQty", "qcQty", "releasedQty"].includes(qtyKey) ? "NA" : qty;

  return (
    <div>
      <Paper className={classes.root} square elevation={3}>
        {/** Row1 */}
        <div className={classes.row2}>
          <LinearProgress value={progress} barBackgroundColor={colors.barBackgroundColor} barColor={colors.barColor} qty={finalQty} />
        </div>

        {/** Row2 */}
        <div className={classes.row3}>
          <div>
            <Tooltip title={"Start Time"} placement="top" arrow>
              <Typography style={{ fontSize: 12 }}>
                {isEmpty(startTime) || isEmpty(utc_offset) ? "-" : format(startTime, utc_offset, "dd MMM, HH:mm")}​
              </Typography>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Last Updated Time" placement="top" arrow>
              <Typography style={{ fontSize: 12 }}>
                {isEmpty(endTime) || isEmpty(utc_offset) ? "-" : format(endTime, utc_offset, "dd MMM, HH:mm")}​ ​
              </Typography>
            </Tooltip>
          </div>
        </div>
      </Paper>
    </div>
  );
};

export default KanbanCard;
